import { createSelector } from 'reselect';
import { List } from 'immutable';
import { ASS_REQUESTS } from '../constants/assistanceRequest.constants';
import { initialState } from '../reducers/assistanceRequest.reducer';
import { selectMergedAlarmList } from './alarm.selector';
import { selectState as selectAppState } from './app.selectors';
import { v4RequestsOnOwnPage } from '../../containers/AlarmPage/functions';
import { isAssistanceRequestAlarm } from '../../utils/models/v4AlarmSituation';
import { toV3AssistanceRequest } from '../../utils/v4AssistanceRequest';

const selectState = state => state[ASS_REQUESTS] || initialState;
const selectData = state => selectState(state).get('data');

// Imports resolved at call time: both sit in an import cycle (via configureStore) with this module.
const selectMergedAlarms = state => selectMergedAlarmList()(state);
const selectUser = state => selectAppState(state).get('currentUser');

// V3 users list V4 assistance requests on this page; everyone else keeps them in Alerts.
// Shared, so each list change maps them once for every reader.
const selectV4Requests = createSelector(
	[selectMergedAlarms, selectUser],
	(alarms, user) => (v4RequestsOnOwnPage(user)
		? alarms.filter(isAssistanceRequestAlarm).map(toV3AssistanceRequest)
		: List())
);

export const selectAssistanceRequests = () => createSelector(
	[selectData, selectV4Requests],
	(data, v4) => (v4.size ? data.toList().concat(v4) : data.toList()).sortBy(a => -a.get('time'))
);
export const selectAssistanceRequestsFetched = () => createSelector(selectState, state => state.get('fetched'));
export const selectOpenAssistanceRequests = () => createSelector(
	[selectData, selectV4Requests],
	(data, v4) => {
		const open = data.toList().sortBy(a => -a.get('id')).filter(a => a.isOpen);
		const v4Open = v4.filter(a => a.isOpen);
		if (!v4Open.size) return open;
		// V4 ids are uuids, so the two merge on time; the stable sort keeps V3's id order on ties.
		return open.concat(v4Open).sortBy(a => -a.get('time'));
	}
);
export const selectActiveAssistantRequestId = () => createSelector(selectState, state => state.get('active'));
export const selectShowAssistantRequestDialog = () => createSelector(selectState, state => state.get('showDialog'));
export const selectAssistanceRequestTileConfig = () => createSelector(selectState, state => state.get('tileConfig'));
export const selectAssistanceRequestTargetAlarm = () => createSelector(selectState, state => state.get('alarm') || null);
